import { useState, useEffect } from "react";
import FormTienda from "../Components/FormTienda";
import imgLogo from "../assets/logoMiniso123.jpg";
import ResultTable from "../Components/ResultTable";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import {FiMenu} from "react-icons/fi";
import BasicMenu from "../Components/BasicMenu.js";
import { myURL } from "../assets/enviroment.js";
import useUser from "../../../hooks/useUser";
import { useNavigate } from "react-router";

const MonitorTiendas = () => {
  /* const isMobile = useMediaQuery({
    query: "(max-width: 760px)",
  }); */
  const isDesktop = useMediaQuery({
    query: "(min-width: 761px)",
  });
  const [date, setDate] = useState("");
  const [tiendas, setTiendas] = useState([]);
  const [dataTiendas, setDataTiendas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [a, b, c, d, e, f, g, monitorUser, setMonitorUser, setDataMonitorLocalStorage, initialMonitorUser] = useUser();
  const navigate = useNavigate();


  useEffect(() => {
    if (monitorUser?.user === "") {
      //console.log("monitorUser is FALSE:..", monitorUser);
      navigate("/loginMonitor");
    }
  }, [monitorUser]);

  const handleLogout = () => {
    setDataMonitorLocalStorage(initialMonitorUser);
    setMonitorUser(initialMonitorUser);
    //console.log("haciendo Logout:..", initialMonitorUser);
    navigate("/loginMonitor");
  };

  const handleConsulta = async (e) => {
    try {
      e.preventDefault();

      const dataConsulta = {
        date,
        tiendas,
      };
      console.log("Consulta:..", dataConsulta);
      setLoading(true);
      //const prodUrl = "http://192.168.84.117:9088/api/monitorTiendas";
      //const localUrl = "http://localhost:5000/api/monitorTiendas";
      //const devEnv= true;
      /**
       * <add name="Access-Control-Allow-Origin" value="*" />
        <add name="Access-Control-Allow-Headers" value="Content-Type" />
        <add name="Access-Control-Allow-Methods" value="GET, POST, PUT, DELETE, OPTIONS" />
       */
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
      };
      const res = await axios.post(`${myURL}monitorTiendas`, dataConsulta, { headers });
      if (res) setLoading(false);
      console.log(res?.data);

      const dataArray = res?.data;
      let tempArray = [];
      if (dataArray?.length > 0) {
        setError(false);
        dataArray.forEach((tienda) => {
          if (tienda?.error === "" || tienda?.error === undefined) {
            //console.log("Error en la consulta", tienda?.error);
            //setError(true);
            tempArray.push(tienda);
          }
        });
      }
      setDataTiendas(tempArray || []);

      if (dataArray?.length === 0 || !dataArray) {
        //Error en la consulta
        console.log("Error en la consulta");
        setError(true);
      }
    } catch (error) {
      console.log("No se pudo realizar la consulta:...", error);
      setLoading(false);
      setError(true);
    }
  };
  return (
    <div className="row ms-1">
      
      <div className="d-flex justify-content-center align-items-center gap-2">
        <img
          style={{ width: "50px" }}
          className="mt-1"
          src={imgLogo}
          alt="imgLogo"
        />
        <h2 className="text-center text-secondary">Monitoreo Tiendas</h2>
        <button onClick={handleLogout} type="button" className="btn btn-outline-info">Logout</button>
      </div>
      <div className="d-flex justify-content-end me-3">
       <BasicMenu/> 
      
      </div>
      
      <div className="col-12 col-md-6">
        <FormTienda
          setError={setError}
          date={date}
          tiendas={tiendas}
          setDate={setDate}
          setTiendas={setTiendas}
          dataTiendas={dataTiendas}
          setDataTiendas={setDataTiendas}
        />
      </div>
      <div className={isDesktop ? "col-12 col-md-6" : "col-12 col-md-6 my-3"}>
        <div
          className={
            isDesktop
              ? "d-flex bg-light flex-column justify-content-center align-items-center h-75 border rounded w-75"
              : "d-flex bg-light flex-column justify-content-center align-items-center h-100 border rounded w-100"
          }
        >
          <h5 className=" text-muted">Datos de Consulta:</h5>
          <div className="d-flex gap-1 align-items-center">
            <h6 className="text-secondary">Fecha:</h6>
            <h6 className="text-center">{date}</h6>
          </div>
          <div className="d-flex gap-1 align-items-center">
            <h6 className="text-secondary">Tienda(s):</h6>
            <h6 className="text-center">{tiendas.toString()}</h6>
          </div>
        </div>
      </div>
      {tiendas?.length > 0 && !loading && dataTiendas.length === 0 && (
        <h6 className="text-center text-success opacity-50 small">
          Ahora puedes realizar tu consulta.{" "}
        </h6>
      )}
      {tiendas?.length > 0 && loading && dataTiendas.length === 0 && (
        <h6 className="text-center text-success opacity-50 small">
          Estamos realizando tu consulta...{" "}
        </h6>
      )}
      {tiendas?.length > 0 && !loading && dataTiendas.length > 0 && (
        <h6 className="text-center text-success opacity-50 small">
          Ahora puedes ver el resultado de tu consulta.{" "}
        </h6>
      )}
      <button
        disabled={
          tiendas.length === 0 || loading
            ? true
            : false
        }
        className="btn btn-primary w-50 ms-auto me-auto"
        onClick={handleConsulta}
      >
        {loading && <Spinner animation="border" variant="light" />}
        {!loading && dataTiendas.length === 0 && "Consultar"}
        {!loading && dataTiendas.length > 0 && "Realizar la misma consulta"}
      </button>
      <div className="container mt-3">
        {!error && dataTiendas?.length > 0 && (
          <ResultTable dataTiendas={dataTiendas} />
        )}
        {error && (
          <h6 className="text-center text-danger">Error en la consulta</h6>
        )}
      </div>
    </div>
  );
};

export default MonitorTiendas;
